import React from "react";
import {
  Box,
  Container,
  Skeleton,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";

export default function TopProductsSk() {
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("xl"));

  return (
    <Container maxWidth="xxl" sx={{ position: "relative" }}>
      {isLgUp ? (
        // ===== Desktop / LG+ Layout =====
        <Stack
          direction="row"
          sx={{ width: "100%", aspectRatio: "2/1", gap: "1.5rem" }}
        >
          {/* Right Side */}
          <Stack
            sx={{
              width: "35%",
              height: "100%",
              borderRadius: "1.5rem",
              overflow: "hidden",
            }}
          >
            <Skeleton
              variant="rectangular"
              sx={{ width: "100%", height: "100%", borderRadius: "1.5rem" }}
            />
          </Stack>

          {/* Left Grid */}
          <Box
            sx={{
              width: "65%",
              height: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gridTemplateRows: "repeat(4, 1fr)",
              gap: "1rem",
            }}
          >
            <Skeleton
              variant="rectangular"
              sx={{
                gridColumn: "1 / 3",
                gridRow: "1 / 3",
                borderRadius: "1.5rem",
                height:"100%",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{ gridColumn: "3", gridRow: "1", borderRadius: "1.5rem",
                height:"100%",
               }}
            />
            <Skeleton
              variant="rectangular"
              sx={{ gridColumn: "4", gridRow: "1", borderRadius: "1.5rem",
                height:"100%",
               }}
            />
            <Skeleton
              variant="rectangular"
              sx={{ gridColumn: "3 / 5", gridRow: "2", borderRadius: "1.5rem",
                height:"100%",
               }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                gridColumn: "1 / 5",
                gridRow: "3 / 5",
                borderRadius: "1.5rem",
                height:"100%",
              }}
            />
          </Box>
        </Stack>
      ) : (
        // ===== Mobile / < LG =====
        <Box
          sx={{
            width: "100%",
            height: "400px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Skeleton
            variant="rectangular"
            sx={{
              width: "90%",
              height: "100%",
              borderRadius: "1.5rem",
            }}
          />
        </Box>
      )}
    </Container>
  );
}
